import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import type { Dispatch } from "redux";
import type { RootState } from "./index";
import type { AppAction } from "./actions";

export const useAppDispatch = () => useDispatch<Dispatch<AppAction>>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
